import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import {GaTrackingEventName, GATrackingEventType} from '../../constants';

export class GATrackingTopNavigationEvent implements GATrackingEvent {

  constructor(
    private title: string,
    private link: string) {
  }

  getEventType(): GATrackingEventType {
    return GATrackingEventType.TopNavigationClick;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: GaTrackingEventName.Navigation,
      label: this.title,
      gtmCustom: {
        link: this.link,
        title: this.title
      }
    };
  }
}
